import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    dayNewsMixin
} from './vue/mixins/day-news';

import { initIntersections } from "./features/new-lazy-load";
import stickyScroll from "./features/sticky-scroll";

import VueScrollTo from "vue-scrollto";

initIntersections();
stickyScroll();

initMain([dayNewsMixin], {
    Trends: () => import('./vue/components/trends/Trends.vue')
}, [VueScrollTo]);
header();